export const basedOnSelection = [
	{ dimension: "style", value: "2283", count: 18 },
	{ dimension: "buyer", value: "A.E.O 5", count: 19 },
	{ dimension: "module_id", value: "Line 02", count: 19 },
];

export const rest = [
	{ dimension: "style", value: "2283 Not", count: 18 },
	{ dimension: "buyer", value: "A.E.O 5 Not", count: 19 },
	{ dimension: "module_id", value: "Line 02 Not", count: 19 },
];

export const orderFilterAPIRequestParams = {
	//factoryId: "ind-clt-dgmt",
	filterKeys: ["buyer", "style", "po", "delivery_date"],
	selectedFilters: {} as object,
};
export type TOrderFilterRequestParams = typeof orderFilterAPIRequestParams;

export const defaultPageProperties = {
	pageNo: 1,
	itemsPerPage: 10,
};

export const legendProperties = [
	{
		value: "Completed",
		iconColor: "#11ad30",
		key: "completedQty",
	},
	{
		value: "In progress",
		iconColor: "#f5be40",
		key: "wipQty",
	},
	{
		value: "Not Picked",
		iconColor: "#cfd0d4",
		key: "notStartedQty",
	},
];
